import { useClientSideSplitTreatments } from "@leafly-com/split-next";

import { getSplitKey } from "utils/split/getSplitKey";

import { Header } from "./Header";

export const MobileExperimentHeader = ({
  disableFixedPosition = false,
  disableScrollCollapse = false,
  isAppBannerCookieDismissed = false,
  minimal = false,
}: {
  disableFixedPosition?: boolean;
  disableScrollCollapse?: boolean;
  isAppBannerCookieDismissed?: boolean;
  minimal?: boolean;
}) => {
  const splitKey = getSplitKey();

  const { treatments, isLoading } = useClientSideSplitTreatments(
    "headerNavLinks_test",
    splitKey
  );

  const showNavLinksTestEnabled =
    !isLoading && treatments.headerNavLinks_test.treatment === "on";

  return (
    <Header
      disableFixedPosition={disableFixedPosition}
      disableScrollCollapse={disableScrollCollapse}
      isAppBannerCookieDismissed={isAppBannerCookieDismissed}
      minimal={minimal}
      showMobileNavLinks={showNavLinksTestEnabled}
    />
  );
};

export default MobileExperimentHeader;
